import { render, staticRenderFns } from "./StatusNotificationBar.vue?vue&type=template&id=3aec0997&scoped=true&"
import script from "./StatusNotificationBar.vue?vue&type=script&lang=ts&"
export * from "./StatusNotificationBar.vue?vue&type=script&lang=ts&"
import style0 from "./StatusNotificationBar.vue?vue&type=style&index=0&id=3aec0997&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aec0997",
  null
  
)

export default component.exports